import {QueryClientProvider} from '@tanstack/react-query';
import {ReactNode} from 'react';

import {useCampaignTracking} from '@/features/campaign/hooks/useCampaignTracking';
import CookieConsentModal from '@/features/cookieConsentModal';
import {useShouldSkipInitScripts} from '@/shared/hooks/useShouldSkipInitScripts';
import queryClient from '@/shared/lib/react-query/queryClient';

import {useInternalAnalytics} from './hooks/useInternalAnalytics';
import {useRegisterFirebaseNotificationWorker} from './hooks/useRegisterFirebaseNotificationWorker';
import {useRollbar} from './hooks/useRollbar';

const App = ({children}: {children: ReactNode}) => {
  const skipInit = useShouldSkipInitScripts();

  useRegisterFirebaseNotificationWorker({skipInit});
  useRollbar();
  useCampaignTracking();

  // Should use after useCampaignTracking ↑ to send a campaign to analytics
  useInternalAnalytics();

  return (
    <QueryClientProvider client={queryClient}>
      <CookieConsentModal />
      {children}
    </QueryClientProvider>
  );
};

export default App;
